
import { defineComponent } from 'vue';
import AdListSimilarItem from './AdListSimilarItem.vue';
import { adService } from '../AdService';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'AdListSimilar',
  components: {
    AdListSimilarItem,
  },
  props: {
    adFrontId: String,
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      isLoading: false,
      locations: null,
      pagedList: {
        totalCount: 0,
        data: [],
      },
      queryParams: {
        page: 1,
        pageSize: 10,
        sortBy: 'distance',
        adFrontId: this.adFrontId,
      },
    };
  },
  computed: {
    show(): boolean {
      return this.hasSimilar || this.hasLocations;
    },
    hasSimilar(): boolean {
      return this.pagedList && this.pagedList.data.length > 0;
    },
    hasLocations(): boolean {
      return this.locations && this.locations.length > 0;
    },
  },
  async created() {
    await this.search();
  },
  methods: {
    pageChangeHandle(value: number) {
      this.queryParams.page = value;
    },
    async search() {
      try {
        this.isLoading = true;
        this.pagedList = (await adService.getSimilar(this.queryParams)).data;
        this.locations = (await adService.getLocations({ adFrontId: this.adFrontId })).data;
      } catch (error) {
        //this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    scrollLeft() {
      if (this.$refs.scrollContent) {
        (this.$refs.scrollContent as any).scrollLeft -= 361;
      }
    },
    scrollRight() {
      if (this.$refs.scrollContent) {
        (this.$refs.scrollContent as any).scrollLeft += 361;
      }
    },
  },
});
